import api from "../AllRisk/baseApi.js";

export default {

    SendMail(subject, toAddresses, ccAddresses, htmlBody) {

        // console.log("mail with subject", subject, "sent to", toAddresses, "sent cc", ccAddresses, "message", htmlBody);

        //////////////////////////////////////////////////////////
        // todo
        //toAddresses = [ "massimo.tiefenthaler@tcconsulting.it" ];
        //ccAddresses = [];
        //////////////////////////////////////////////////////////

        let email = {
            Subject: subject,
            MailAddresses: toAddresses,
            MailAddressesCC: ccAddresses,
            HtmlBody: htmlBody
        }
        return api.post("EmailSender/SendEmail", email);
    }
}